import { RecruiterAiInterviewsState, AiInterviewInvite } from "@/store/modules/recruiter_ai_interviews/interfaces";

export default {
  SET_AI_INTERVIEW_INVITES(
    state: RecruiterAiInterviewsState,
    invites: AiInterviewInvite[]
  ): void {
    state.invites = invites;
  },
  ADD_AI_INTERVIEW_INVITE(
    state: RecruiterAiInterviewsState,
    invite: AiInterviewInvite
  ): void {
    state.invites = [invite, ...state.invites];
  },
  SET_AI_INTERVIEW_INVITES_INITIALIZED(
    state: RecruiterAiInterviewsState,
    initialized: boolean
  ): void {
    state.initialized = initialized;
  }
};

